import type { ProjectSolarPotential } from '@/api/queries/project/useGetProjectSolarPotential';
import type { SolarRecommendedApplianceFieldsFragment } from '@/gql/graphql';

type SolarGeometry = ProjectSolarPotential['geometry'];

/** Keep product options consistent with the dimensions used to pack the roof. */
export const solarPanelAppliancesForLayout = (
  appliances: SolarRecommendedApplianceFieldsFragment[],
  geometry: SolarGeometry,
  geometryMode: boolean
) => {
  const dimensions = geometry?.panelDimensions;
  if (!geometryMode || !dimensions) return appliances;

  return appliances.filter(({ appliance }) => {
    const spec = appliance.productSpec;
    return (
      spec.panelCapacityW === dimensions.capacityWatts &&
      spec.solarPanelWidthM != null &&
      spec.solarPanelHeightM != null &&
      Math.abs(spec.solarPanelWidthM - dimensions.widthMeters) <= 0.001 &&
      Math.abs(spec.solarPanelHeightM - dimensions.heightMeters) <= 0.001
    );
  });
};
